/** Where to go after login. Only paths on this site, so a link cannot send a child elsewhere. */
export function safeNextPath(next: string | null): string {
  return next && next.startsWith('/') && !next.startsWith('//') ? next : '/';
}
